<template>
  <div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号">
          <el-input size="small" v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column fixed prop="orderNo" label="订单号" width="150">
      </el-table-column>
      <el-table-column label="技师信息">
        <template slot-scope="scope">
          <el-image :src='scope.row.waiter.avatarUrl' style="width:30px;height:30px"></el-image><br /> {{ scope.row.waiter.username }}<br />
        </template>
      </el-table-column>
      <el-table-column prop="matinfo" label="物料信息" width="150">
        <template slot-scope="scope">
          {{ scope.row.maproduct.productName }}<br />{{ scope.row.maproduct.productPrice }}<br />{{ scope.row.maproduct.total_num }}<br />
        </template>

      </el-table-column>
      <el-table-column prop="pay_price" label="实际支付" width="150">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      <el-table-column prop="pay_type" label="支付类型" width="150">
      </el-table-column>
      <el-table-column prop="order_status_text" label="订单状态">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="primary" size="small">查看详情</el-button>
          <el-button type="danger" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import materialApi from "@/api/material.js";
export default {
  data() {
    return {
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 4,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        search: "",
        orderNo: "",
        style_id: "",
        createTime: ""
      },
      tableData: []
    };
  },
  created() {
    this.getmaterialOrder();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getmaterialOrder();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getmaterialOrder();
    },
    /*获取列表*/
    getmaterialOrder() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      self.loading = true;
      materialApi
        .materialOrder(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: "/music/music/edit",
        query: {
          orderId: row.orderId,
          scene: "edit"
        }
      });
    },
    /*删除*/
    delClick: function(row) {
      let self = this;
      self
        .$confirm("确定删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          materialApi
            .Musicdelete({
              orderId: row.orderId
            })
            .then(data => {
              self.$message({
                message: "删除成功",
                type: "success"
              });
              self.getmaterialOrder();
            });
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/materials/order/index1.vue